'use client';

import 'swiper/css';
import 'swiper/css/a11y';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import SanityImage from '@/components/shared/SanityImage';
import cn from '@/lib/cn';
import { VIEWPORT_SIZES } from '@/lib/constants';

export default function Slider({
  className = undefined,
  images,
}: {
  className?: string;
  images: NonNullable<PageCareerQueryResult>['socialMedia']['images'];
}) {
  return (
    <Swiper
      className={cn(
        '!overflow-visible [--swiper-wrapper-transition-timing-function:linear]',
        className,
      )}
      allowTouchMove={false}
      autoplay={{
        delay: 0,
        disableOnInteraction: false,
      }}
      loop
      modules={[Autoplay]}
      slidesPerView={2}
      spaceBetween={12}
      speed={images.length * 1_000}
      breakpoints={{
        [VIEWPORT_SIZES.md]: {
          slidesPerView: 3,
        },
        [VIEWPORT_SIZES.lg]: {
          slidesPerView: 4.2,
        },
      }}
    >
      {[...images, ...images].map((image, i) => (
        <SwiperSlide
          key={`${i}-${image._key}`}
          aria-hidden={i >= images.length}
        >
          <SanityImage
            className="aspect-square rounded-lg object-cover"
            image={image}
            sizes={`(min-width: ${VIEWPORT_SIZES.lg}px) 25vw, (min-width: ${VIEWPORT_SIZES.md}px) 33vw, 50vw`}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
